export class ObservationTypes {
    public static readonly observations = [
        { "id": 50, "type": "string", "unit": "" },
        { "id": 51, "type": "string", "unit": "" },
        { "id": 52, "type": "int", "unit": "" },
        { "id": 53, "type": "int", "unit": "" },
        { "id": 54, "type": "int", "unit": "" },

        { "id": 100, "type": "string", "unit": "" },
        { "id": 101, "type": "string", "unit": "" },
        { "id": 102, "type": "int", "unit": "" },
        { "id": 103, "type": "double", "unit": "" },
        { "id": 104, "type": "double", "unit": " dBm" },
        { "id": 105, "type": "string", "unit": "" },
        { "id": 106, "type": "int", "unit": "" },
        { "id": 107, "type": "double", "unit": " dB" },
        { "id": 108, "type": "double", "unit": " dB" },
        { "id": 109, "type": "int", "unit": " bytes" },
        { "id": 110, "type": "int", "unit": " bytes" },
        { "id": 111, "type": "string", "unit": "" },
        { "id": 112, "type": "string", "unit": "" },
        { "id": 113, "type": "string", "unit": "" },
        { "id": 114, "type": "string", "unit": "" },

        { "id": 115, "type": "string", "unit": "" },
        { "id": 116, "type": "int", "unit": "" },
        { "id": 117, "type": "int", "unit": "" },
        { "id": 120, "type": "double", "unit": "" },

        { "id": 150, "type": "string", "unit": "" },
        { "id": 151, "type": "string", "unit": "" },
        { "id": 152, "type": "string", "unit": "" },

        { "id": 153, "type": "string", "unit": "" },
        { "id": 154, "type": "string", "unit": "" },
        { "id": 155, "type": "string", "unit": "" },
        { "id": 156, "type": "string", "unit": "" },
        { "id": 157, "type": "string", "unit": "" },
        { "id": 158, "type": "string", "unit": "" },

        { "id": 200, "type": "onedecimal", "unit": " Volts" },
        { "id": 201, "type": "double", "unit": "%" },
        { "id": 202, "type": "double", "unit": "°C" },
        { "id": 203, "type": "int", "unit": "" },
        { "id": 204, "type": "float", "unit": "" },
        { "id": 205, "type": "string", "unit": "" },
        { "id": 206, "type": "threedecimal", "unit": " Ah" },

        { "id": 207, "type": "double", "unit": "" },
        { "id": 208, "type": "double", "unit": "" },
        { "id": 209, "type": "double", "unit": "" },
        { "id": 210, "type": "double", "unit": "" },
        { "id": 211, "type": "double", "unit": "" },

        { "id": 212, "type": "int", "unit": "" },

        { "id": 220, "type": "int", "unit": "" },
        { "id": 221, "type": "int", "unit": "" },
        { "id": 222, "type": "int", "unit": "" },
        { "id": 223, "type": "int", "unit": "" },
        { "id": 230, "type": "bool", "unit": "" },

        { "id": 250, "type": "int", "unit": "" },
        { "id": 251, "type": "int", "unit": "" },
        { "id": 300, "type": "position", "unit": "" },
        { "id": 301, "type": "float", "unit": "°" },
        { "id": 302, "type": "float", "unit": " km/h" },
        { "id": 303, "type": "float", "unit": " km/h" },
        { "id": 304, "type": "float", "unit": "" },
        { "id": 305, "type": "int", "unit": "" },

        { "id": 306, "type": "int", "unit": "" },
        { "id": 307, "type": "int", "unit": "" },
        { "id": 308, "type": "int", "unit": "" },

        { "id": 310, "type": "float", "unit": "°" },
        { "id": 321, "type": "float", "unit": " G" },

        { "id": 350, "type": "double", "unit": "" },

        { "id": 351, "type": "int", "unit": " m" },
        { "id": 400, "type": "All", "unit": "" },
        { "id": 401, "type": "All", "unit": "" },
        { "id": 402, "type": "All", "unit": "" },
        { "id": 410, "type": "All", "unit": "" },
        { "id": 411, "type": "All", "unit": "" },
        { "id": 412, "type": "int", "unit": "" },

        { "id": 450, "type": "string", "unit": "" },
        { "id": 451, "type": "bool", "unit": "" },
        { "id": 452, "type": "string", "unit": "" },
        { "id": 453, "type": "string", "unit": "" },
        { "id": 454, "type": "string", "unit": "" },
        { "id": 455, "type": "string", "unit": "" },
        { "id": 456, "type": "bool", "unit": "" },

        { "id": 457, "type": "bool", "unit": "" },
        { "id": 458, "type": "string", "unit": "" },
        { "id": 459, "type": "All", "unit": "" },
        { "id": 460, "type": "int", "unit": "" },
        { "id": 461, "type": "string", "unit": "" },
        { "id": 462, "type": "double", "unit": "" },
        { "id": 463, "type": "double", "unit": "" },
        { "id": 464, "type": "bool", "unit": "" },

        { "id": 465, "type": "double", "unit": "" },
        { "id": 466, "type": "double", "unit": "" },
        { "id": 467, "type": "double", "unit": "" },
        { "id": 468, "type": "string", "unit": "" },
        { "id": 470, "type": "int", "unit": "" },
        { "id": 471, "type": "string", "unit": "" },

        { "id": 500, "type": "int", "unit": " PSI" },
        { "id": 501, "type": "int", "unit": " PSI" },

        { "id": 510, "type": "string", "unit": "" },
        { "id": 511, "type": "string", "unit": "" },
        { "id": 520, "type": "int", "unit": "" },
        { "id": 521, "type": "int", "unit": "" },
        { "id": 530, "type": "double", "unit": "" },
        { "id": 531, "type": "double", "unit": "" },

        { "id": 540, "type": "int", "unit": "" },
        { "id": 541, "type": "int", "unit": "" },

        { "id": 600, "type": "string", "unit": "" },
        { "id": 601, "type": "int", "unit": " bytes" },
        { "id": 602, "type": "int", "unit": " bytes" },
        { "id": 610, "type": "int", "unit": " bytes" },
        { "id": 611, "type": "int", "unit": " bytes" },
        { "id": 612, "type": "int", "unit": " bytes" },
        { "id": 613, "type": "int", "unit": " bytes" },
        { "id": 614, "type": "int", "unit": " bytes" },
        { "id": 620, "type": "string", "unit": "" },

        { "id": 630, "type": "bool", "unit": "" },
        { "id": 631, "type": "bool", "unit": "" },
        { "id": 632, "type": "bool", "unit": "" },
        { "id": 633, "type": "bool", "unit": "" },
        { "id": 640, "type": "bool", "unit": "" },
        { "id": 641, "type": "int", "unit": "" },
        { "id": 642, "type": "bool", "unit": "" },
        { "id": 643, "type": "int", "unit": "" },
        { "id": 644, "type": "int", "unit": "" },

        { "id": 650, "type": "int", "unit": "" },
        { "id": 651, "type": "string", "unit": "" },
        { "id": 652, "type": "int", "unit": "" },
        { "id": 653, "type": "int", "unit": "" },
        { "id": 654, "type": "string", "unit": "" },
        { "id": 655, "type": "int", "unit": "" },
        { "id": 656, "type": "int", "unit": "" },
        { "id": 657, "type": "int", "unit": "" },
        { "id": 660, "type": "int", "unit": "" },


        { "id": 700, "type": "string", "unit": "" },
        { "id": 701, "type": "double", "unit": "" },
        { "id": 711, "type": "double", "unit": "" },
        { "id": 712, "type": "double", "unit": "" },
        { "id": 713, "type": "double", "unit": "" },
        { "id": 714, "type": "double", "unit": "" },
        { "id": 715, "type": "double", "unit": "" },
        { "id": 800, "type": "double", "unit": "" },

        { "id": 510, "type": "int", "unit": "" },
        { "id": 511, "type": "int", "unit": "" }
    ];

    /**
     * Map DP undock result bit
     */
    public static readonly dpUndockResult = [
        { "id": 0, "name": "No response" },
        { "id": 1, "name": "Undock OK" },
        { "id": 2, "name": "Is free" },
        { "id": 3, "name": "Is error" },
        { "id": 4, "name": "Is timeout" },
        { "id": 5, "name": "Control activation failed" }
    ];

    /**
     * Map battery status
     */
    public static readonly batStatus = [
        { "id": 0, "name": "Deep Sleep" },
        { "id": 1, "name": "Warm-Up" },
        { "id": 2, "name": "Charging" },
        { "id": 3, "name": "Warm-Up and Charging" },
        { "id": 4, "name": "In-Use" },
        { "id": 5, "name": "In-Use and Warm-Up" },
        { "id": 6, "name": "In-Use and Charging" },
        { "id": 7, "name": "In-Use and Charging and Warm-Up" }
    ];

    /**
     * Map bike states
     */
    public static readonly BikeStates = [
        { "id": 10, "name": "Running" },
        { "id": 20, "name": "Docked" },
        { "id": 30, "name": "Parked Vertically" },
        { "id": 31, "name": "Parked Horizontally" }
    ];

    /**
     * Map lock states
     */
    public static readonly LockStates = [
        { "id": 10, "name": "Locked" },
        { "id": 11, "name": "Unlocked" },
        { "id": 20, "name": "InTransition" }
    ];

    /**
     * Map power states
     */
    public static readonly PowerStates = [
        { "id": 10, "name": "Standby" },
        { "id": 11, "name": "Running" },
        { "id": 12, "name": "Hibernating" },
        { "id": 20, "name": "Charging Finished" },
        { "id": 21, "name": "Charging Normally" }
    ];

    /**
     * Map bike errors
     */
    public static readonly BikeErrors = [
        { "id": 0, "name": "" },
        { "id": 100, "name": "Lock Out Of Sync" },
        { "id": 200, "name": "Hibernation Activated" },

        { "id": 300, "name": "Controller Over Current" },
        { "id": 301, "name": "Controller Over Pressure" },
        { "id": 302, "name": "Controller Under Voltage" },
        { "id": 303, "name": "Controller Braked Already" },
        { "id": 304, "name": "Controller Throttle not back in position" },
        { "id": 305, "name": "Controller throttle fault" },
        { "id": 306, "name": "Controller low voltage protection" },
        { "id": 307, "name": "Controller over voltage protection" },
        { "id": 308, "name": "Controller Hall signal wire fault" },
        { "id": 309, "name": "Controller phase wire fault" },
        { "id": 310, "name": "Controller motor temperature protection" },
        { "id": 311, "name": "Controller motor temperature sensor fault" },
        { "id": 312, "name": "Controller Temperature protection" },
        { "id": 313, "name": "Controller temperature sensor fault" },
        { "id": 314, "name": "Controller current sensor fault" },
        { "id": 315, "name": "Controller headlight fault" },
        { "id": 316, "name": "Controller brake detection circuit fault" },
        { "id": 317, "name": "Controller 15V detection fault" },
        { "id": 318, "name": "Controller key detection circuit fault" },
        { "id": 319, "name": "Controller Speed sensor failure" },
        { "id": 320, "name": "Controller Torque sensor failure" },
        { "id": 321, "name": "Controller Unscheduled Timeout" },
        { "id": 322, "name": "Controller Power button timeout" },
        { "id": 323, "name": "Controller CAN TX Buffer Full" },
        { "id": 324, "name": "Controller CAN RX Buffer Full" },

        { "id": 400, "name": "Battery High Voltage" },
        { "id": 401, "name": "Battery Low Voltage" },
        { "id": 402, "name": "Battery high cell total current" },
        { "id": 403, "name": "Battery Temperature high" },
        { "id": 404, "name": "Battery Temperature low" },
        { "id": 405, "name": "Battery SOC High" },
        { "id": 406, "name": "Battery SOC Low" },

        { "id": 500, "name": "DP Over Current" },
        { "id": 501, "name": "DP DockedStep Charge Volt Error" },
        { "id": 502, "name": "DP DockedStep Charge Current Error" },
        { "id": 503, "name": "DP DockedStep LinkRecovery Strong" },
        { "id": 504, "name": "DP DockedStep LinkRecovery Light" },
        { "id": 505, "name": "DP Accept Current Test Right Error" },
        { "id": 506, "name": "DP Accept Current Test Left Error" },
        { "id": 507, "name": "DP Accept Withdraw Error" },
        { "id": 508, "name": "DP Accept Solenoid Sensors Error" },
        { "id": 509, "name": "DP UndockStep Cancelled" },
        { "id": 510, "name": "DP UndockStep Solenoid Sensor Failure" },
        { "id": 511, "name": "DP DPLost" },
        { "id": 512, "name": "DP Undock Busy" },
        { "id": 513, "name": "DP Undock Not in this phase" },
        { "id": 514, "name": "DP Undock Charger Precheck Failed" },
        { "id": 515, "name": "DP Undock Precheck Error" },
        { "id": 516, "name": "DP Undock Unknown Error" },
        { "id": 517, "name": "DP Charge Busy" },
        { "id": 518, "name": "DP Charge Not in this phase" },
        { "id": 519, "name": "DP Charge Charger precheck failed" },
        { "id": 520, "name": "DP Charge Precheck Error" },
        { "id": 521, "name": "Dp Charge Unknown Error" },
        { "id": 522, "name": "DP General Busy" },
        { "id": 523, "name": "DP General Not in this phase" },
        { "id": 524, "name": "DP General Charger Precheck Failed" },
        { "id": 525, "name": "DP General Precheck Error" },
        { "id": 526, "name": "DP General Unknown Error" },
        { "id": 527, "name": "DP Undock No contact with DP" },
        { "id": 528, "name": "DP Undock Failed, could not activate controller" },
        { "id": 529, "name": "DP Undock General Fail, returned to Docked" },
    ];

    /**
     * Map bike warnings
     */
    public static readonly BikeWarnings = [
        { "id": 100, "name": "Charging Stopped due to Full Battery (Defined in settings parameter 202)" },
        { "id": 101, "name": "Charging Stopped due to High Voltage (> 41.7 V)" },
        { "id": 102, "name": "Settings downloaded" },
        { "id": 103, "name": "Docking Locations Downloaded" },
        { "id": 104, "name": "Lock State Change Timeout" }
    ];

    /**
     * Map docking point state
     */
    public static readonly DockingPointState = [
        { "id": 1, "name": "Available" },
        { "id": 2, "name": "Occupied" },
        { "id": 3, "name": "Disabled" }
    ];

    /**
     * Map docking point docking state
     */
    public static readonly DockingPointDockingState = [
        { "id": 0, "name": "Init" },
        { "id": 1, "name": "Docking" },
        { "id": 2, "name": "Docked" },
        { "id": 3, "name": "DP Lost" },
        { "id": 4, "name": "Undocking" },
        { "id": 5, "name": "Free" },
        { "id": 6, "name": "Undocked" }
    ];
}


